import Button from "@restart/ui/esm/Button";
import React, { useEffect } from "react";
import { Card, Image } from "react-bootstrap";
import ForCompFace from "../assets/images/ForCompFace.png";
import forCompLoc from "../assets/images/forCompLoc.png";
import { imageUrl } from "../Config/apiUrl";
import Aos from "aos";
import Carousel from "react-elastic-carousel";
import { useHistory } from "react-router";

const ForCompaniesCard = ({ pageData, craftmen }) => {
  const count = new Array(4).fill("");
  const history = useHistory();

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 1 },
    { width: 850, itemsToShow: 3 },
    { width: 1150, itemsToShow: 3 },
    { width: 1750, itemsToShow: 3 },
  ];

  return (
    <div>
      <h3 className="text-center mb-4 whito" data-aos="fade-up" data-aos-duration="3000">
        {pageData?.sec2Heading}
        {/* <span className="regular whito">For </span>
        companies */}
      </h3>

      <p className="text-center mb-5 whito" style={{ whiteSpace: "pre-line" }}>
        {pageData?.sec2Description}
      </p>
      <p className="text-center mb-5 whito">
        This way we make sure you get the most qualified employees for your
        company!
      </p>
      <div className="text-center mb-5 whito btn_for_comp">
        <Button
          onClick={() => {
            history.push("/signup");
          }}
        >
          Create your company profile
        </Button>
      </div>

      <Carousel
        breakPoints={breakPoints}
        className="custom_carousel"
        itemsToScroll={1}
        itemsToShow={3}
      >
        {craftmen.map((item, i) => (
          <Card
            key={i}
            className="for_comp_main text-center"
            onClick={() => {
              history.push(`/ctaftman-profile?id=${item._id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="company-img-box">
              <Card.Img
                className="for_comp_main_img"
                src={`${imageUrl}${item?.photo}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ForCompFace;
                }}
              />
            </div>
            <Card.Body>
              <div className="company-card">
                <Card.Title className="text-center font-22">
                  {item?.userName}
                </Card.Title>
                <Card.Text>{item?.education}</Card.Text>
                <Card.Text>
                  <div>
                    <Image src={forCompLoc} /> {item?.address}
                  </div>
                </Card.Text>

                <div className="for_comp_tags">
                  {item?.skills?.map((e, i) => (
                    <h6 key={i}>{e}</h6>
                  ))}
                </div>
              </div>

              {/* <div className="for_comp_tags second">
                <h6>Skill 01</h6>
                <h6>Skill 01</h6>
              </div> */}
            </Card.Body>
          </Card>
        ))}
      </Carousel>
    </div>
  );
};

export default ForCompaniesCard;
